// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7_webpack@5.76.1/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#menu-halaman>.active>a[data-v-26e6c01e],#menu-halaman>.is-active>a[data-v-26e6c01e]{border-radius:9999px;background-image:linear-gradient(to bottom right, var(--tw-gradient-stops));--tw-gradient-from:#0033cc;--tw-gradient-to:rgb(0 51 204 / 0);--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to);--tw-gradient-to:#003399}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
